<ng-container *transloco="let t">
  <ng-container *ngFor="let item of sideNavService.itemsVisible$ | async">
    <div class="sidenav-subheader" *ngIf="item.header; else navItem">{{ t(item.name) }}</div>

    <ng-template #navItem>
      <a
        [routerLink]="item.link"
        routerLinkActive="active-nav"
        [matBadge]="item.badge"
        matBadgeOverlap="true"
        matRipple
        [matRippleUnbounded]="false"
      >
        <mat-icon>{{ item.icon }}</mat-icon>
        <span>{{ t(item.name) }}</span>
      </a>
    </ng-template>
  </ng-container>
</ng-container>
